import React from 'react';

const FeaturedPoiTypeBadge = () => {
    return (
        <div className="text-xs bg-brand rounded-full py-0.5 px-2 text-white absolute -top-4 left-0 shadow-md">
            Novo!
        </div>
    );
};

export default FeaturedPoiTypeBadge;
